// Взаимное исключение аудиоплееров в приложении.
// Один owner держит «микрофон» — claim другого вызывает stop предыдущего.

export type ExclusiveAudioOwner =
	| "tutor-message-tts"
	| "character-message-tts"
	| "audio-recap"
	| "ad-hoc"
	| "voice-live"
	| "voice-grid"
	// Плеер видео-материала (M5.2): у видео тоже есть звуковая дорожка, и без
	// участия в арбитраже оно играло поверх мини-плеера рекапа и озвучки ответа
	// репетитора одновременно.
	| "material-video";

type StopHandler = () => void;

const stopHandlers = new Map<ExclusiveAudioOwner, StopHandler>();
let currentOwner: ExclusiveAudioOwner | null = null;

/** Зарегистрировать stop-handler owner'а (идемпотентно, на module init). */
export function registerExclusiveAudioStop(owner: ExclusiveAudioOwner, stop: StopHandler): void {
	stopHandlers.set(owner, stop);
}

/** Забрать exclusive playback. Стопит предыдущего owner'а, если он другой. */
export function claimExclusiveAudio(owner: ExclusiveAudioOwner): void {
	if (currentOwner && currentOwner !== owner) {
		const stop = stopHandlers.get(currentOwner);
		try {
			stop?.();
		} catch {
			/* ignore stop errors from other players */
		}
	}
	currentOwner = owner;
}

/** Освободить ownership (вызывать из onEnd / pause / stop своего плеера). */
export function releaseExclusiveAudio(owner: ExclusiveAudioOwner): void {
	if (currentOwner === owner) currentOwner = null;
}

/** Текущий owner — для тестов / отладки. */
export function getExclusiveAudioOwner(): ExclusiveAudioOwner | null {
	return currentOwner;
}
